import React, { useState } from 'react';
import useOperationalStore from '../../platform/store/useOperationalStore';

const AssignTechModal = ({ onClose, onSubmit, currentTechs = [] }) => {
  const technicians = useOperationalStore(s => s.technicians);
  const [selected, setSelected] = useState(new Set(currentTechs));

  const active = technicians
    .filter(t => t.active !== false)
    .sort((a, b) => (a.order ?? 0) - (b.order ?? 0));

  function toggle(number) {
    setSelected(prev => {
      const next = new Set(prev);
      next.has(number) ? next.delete(number) : next.add(number);
      return next;
    });
  }

  return (
    <div className="tt-modal-backdrop">
      <div className="tt-modal">
        <div className="tt-modal-header">
          <h2 className="tt-modal-title">Assign Technicians</h2>
          <button onClick={onClose} className="tt-modal-close">×</button>
        </div>

        <div className="tt-modal-body">
          <div className="tt-option-list">
            {active.length === 0 && (
              <div className="tt-empty">No active technicians</div>
            )}
            {active.map(tech => {
              const isSelected = selected.has(tech.number);
              return (
                <button
                  key={tech.id}
                  type="button"
                  className={`tt-option-row ${isSelected ? 'is-selected' : ''}`}
                  onClick={() => toggle(tech.number)}
                >
                  <span className="tt-checkbox-mark">{isSelected ? '✓' : ''}</span>
                  <span>#{tech.number} - {tech.name}</span>
                </button>
              );
            })}
          </div>
        </div>

        <div className="tt-modal-footer">
          <button onClick={onClose} className="tt-button tt-button--ghost">
            Cancel
          </button>
          <button onClick={() => onSubmit(Array.from(selected))} className="tt-button tt-button--primary">
            Save
          </button>
        </div>
      </div>
    </div>
  );
};

export default AssignTechModal;
